import React from "react";
// import mapImage from '../../path-to-your-image/Screenshot 2024-07-11 163536.png'; // Update the path as necessary
import "./Location.css";

const ContactMap = () => {
  return (<>
     <h1 style={{ textAlign: "center", marginBottom: "20px", position: "relative" }}>
        <span style={{ borderBottom: "5px solid gold", padding: "3px", display: "inline-block" }}>
          Location
        </span>
      </h1>
    <div className="contact-map-container">
      <div className="contact-info">
        {/* <h2>Our Offices</h2> */}
        <h2>Karimnagar Branch</h2>
        <p>+91 7799880753, +91 9100274050</p>
        <p>suffahhighschoolkarimnagar@gmail.com</p>
        <p>Nayeemnagar</p>
        <p>Karimnagar,</p>
        <p>Telangana - 505001</p>
      </div>
      <div className="map-container">
        <iframe
        title='Suffah Techno E/M High School. [IIT-NEET FOUNDATION].'
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3784.9595422658654!2d79.14560697518976!3d18.440145982637816!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bccd904166dbdcb%3A0xbf362d23dc39b8ee!2sSuffah%20Techno%20E%2FM%20High%20School.%20%5BIIT-NEET%20FOUNDATION%5D.!5e0!3m2!1sen!2sin!4v1720696640359!5m2!1sen!2sin"
          width="auto"
          height="auto"
          style={{border:'0'}}
        //   allowfullscreen=""
        //   loading="lazy" 
        //   referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
        {/* <img alt="Karimnagar Branch Location" />    */}
      </div>
    </div>
          </>
  );
};

export default ContactMap;
